// *************************
// Accordion code with scroll to top
// *************************
document.addEventListener('DOMContentLoaded', function () {
  var group = document.querySelector('.product-info, .Product__Accordions, .Product__Info');
  if (!group) return;
  var details = group.querySelectorAll('details');
  if (details.length) {
    details.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        
        // Close other open accordions
        details.forEach(function (other) {
          if (other !== d && other.open) {
            var summary = other.querySelector('summary');
            if (summary) summary.click(); else other.open = false;
          }
        });
        
        // Scroll to top of clicked accordion minus 176px after 400ms delay
        setTimeout(function() {
          var accordionTop = d.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: accordionTop - 176,
            behavior: 'smooth'
          });
        }, 400);
      });
    });
    return;
  }
});

// *************************
// Product badges (ready to ship, made to order, mixed shipping message banner)
// *************************
function ensureFulfillmentProperty(){
  const typeHost = document.getElementById('ft-init');
  if(!typeHost) return;
  const value = typeHost.dataset.type || 'mto';
  
  const displayValue = value === 'ready' ? 'Ready to ship' : 'Made to order';
  
  const forms = document.querySelectorAll('form[action*="/cart/add"]');
  if(forms.length === 0) return;
  
  forms.forEach(form => {
    let input = form.querySelector('input[name="properties[Fulfillment]"]');
    if(!input){
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Fulfillment]';
      form.appendChild(input);
    }
    input.value = displayValue;
  });
}

async function updatePdpMixedBanner(){
  try{
    const box = document.getElementById('mix-shipping-banner');
    if(!box) return;
    
    const currentType = (document.getElementById('ft-init')?.dataset.type || 'mto').toLowerCase();
    const res = await fetch('/cart.js', { cache: 'no-store' });
    const cart = await res.json();
    
    let hasReady = false, hasMTO = false;
    for(const it of (cart.items || [])){
      const fulfillment = (it.properties && it.properties.Fulfillment || '').toLowerCase();
      if(fulfillment.includes('ready')) hasReady = true;
      if(fulfillment.includes('order')) hasMTO = true;
    }
    
    const mixed = (currentType === 'ready' && hasMTO) || (currentType === 'mto' && hasReady);
    box.style.display = mixed ? 'block' : 'none';
    
  }catch(e){
    console.error('PDP banner update error:', e);
  }
}

function initBanner(){
  ensureFulfillmentProperty();
  setTimeout(updatePdpMixedBanner, 150);
}

if(document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBanner);
} else {
  initBanner();
}

['shopify:section:load','shopify:section:select','cart:updated','cart:refresh','cart:change','product:variant-change','variant:change'].forEach(ev => {
  document.addEventListener(ev, initBanner);
});

const modalObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === 1) {
        const hasBanner = node.id === 'mix-shipping-banner' || 
                         node.querySelector && node.querySelector('#mix-shipping-banner');
        const hasFtInit = node.id === 'ft-init' || 
                         node.querySelector && node.querySelector('#ft-init');
        
        if (hasBanner || hasFtInit) {
          setTimeout(initBanner, 300);
          return;
        }
      }
    }
  }
});

modalObserver.observe(document.body, { childList: true, subtree: true });


// *************************
// Wishlist Hero XHR Interceptor
// This is the code that will add the appropriate Fulfillment: Ready to Ship or Made to Order
// *************************

(function(){
  let lastClickedButton = null;
  let pendingWishlistVariants = new Set();
  const wishlistVariantCache = {};
  
  window._wishlistHandleCache = window._wishlistHandleCache || {};
  
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.product-card__quick-add-button, button[type="submit"]');
    if(btn) {
      lastClickedButton = btn;
    }
    
    const wishlistBtn = e.target.closest('.wishlist-hero-list-card-footer-add-to-cart');
    if(wishlistBtn) {
      pendingWishlistVariants.clear();
      
      const card = wishlistBtn.closest('.wishlist-hero-list-card');
      const productLink = card ? card.querySelector('a[href*="/products/"]') : null;
      
      if(productLink) {
        const href = productLink.getAttribute('href');
        const handleMatch = href.match(/\/products\/([^?]+)/);
        const variantMatch = href.match(/variant=(\d+)/);
        
        if(handleMatch && variantMatch) {
          const productHandle = handleMatch[1];
          const variantId = variantMatch[1];
          
          pendingWishlistVariants.add(variantId);
          window._wishlistHandleCache[variantId] = productHandle;
        }
      }
      
      pendingWishlistVariants.add('ANY');
      setTimeout(() => pendingWishlistVariants.clear(), 10000);
    }
  }, true);
  
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;
  
  XMLHttpRequest.prototype.open = function(method, url, ...args) {
    this._url = url;
    this._method = method;
    return originalXHROpen.call(this, method, url, ...args);
  };
  
  XMLHttpRequest.prototype.send = function(body) {
    const self = this;
    
    if(this._url && this._url.includes('/cart/add')) {
      let variantId = null;
      if(typeof body === 'string') {
        try {
          const parsed = JSON.parse(body);
          variantId = parsed.id || parsed.variant_id;
        } catch(e) {}
      }
      
      const isFromWishlist = pendingWishlistVariants.has(String(variantId)) || pendingWishlistVariants.has('ANY');
      
      if(isFromWishlist && body && variantId) {
        pendingWishlistVariants.delete(String(variantId));
        if(pendingWishlistVariants.size === 1 && pendingWishlistVariants.has('ANY')) {
          pendingWishlistVariants.delete('ANY');
        }
        
        if(wishlistVariantCache[variantId]) {
          const fulfillmentType = wishlistVariantCache[variantId];
          const parsedBody = JSON.parse(body);
          if(!parsedBody.properties) parsedBody.properties = {};
          parsedBody.properties.Fulfillment = fulfillmentType;
          originalXHRSend.call(self, JSON.stringify(parsedBody));
          return;
        }
        
        (async function() {
          try {
            const cachedHandle = window._wishlistHandleCache[variantId];
            
            if(cachedHandle) {
              let fulfillmentType = 'Made to order';
              
              try {
                const pageResponse = await fetch(`/products/${cachedHandle}`);
                const pageHTML = await pageResponse.text();
                const ftInitMatch = pageHTML.match(/data-type=['"]?(ready|mto)['"]?/i);
                
                if(ftInitMatch) {
                  fulfillmentType = ftInitMatch[1] === 'ready' ? 'Ready to ship' : 'Made to order';
                }
              } catch(e) {}
              
              wishlistVariantCache[variantId] = fulfillmentType;
              
              const parsedBody = JSON.parse(body);
              if(!parsedBody.properties) parsedBody.properties = {};
              parsedBody.properties.Fulfillment = fulfillmentType;
              
              originalXHRSend.call(self, JSON.stringify(parsedBody));
              pendingWishlistVariants.delete(String(variantId));
            } else {
              originalXHRSend.call(self, body);
            }
          } catch(e) {
            originalXHRSend.call(self, body);
          }
        })();
        
        return;
      }
    }
    
    return originalXHRSend.call(this, body);
  };
  
  // Fetch interceptor for regular add-to-cart buttons
  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
    let [url, options] = args;
    
    if(typeof url === 'string' && url.includes('/cart/add')) {
      try {
        let body = options?.body;
        let alreadyHasProperty = false;
        
        if(body instanceof FormData) {
          alreadyHasProperty = body.has('properties[Fulfillment]');
        } else if(typeof body === 'string') {
          alreadyHasProperty = body.includes('properties%5BFulfillment%5D') || body.includes('properties[Fulfillment]');
        }
        
        if(alreadyHasProperty) {
          return originalFetch.apply(this, args);
        }
        
        let productHandle = null;
        
        if(lastClickedButton) {
          const productCard = lastClickedButton.closest('product-card[data-product-handle]');
          if(productCard) {
            productHandle = productCard.getAttribute('data-product-handle');
          }
        }
        
        if(!productHandle) {
          const ftInit = document.getElementById('ft-init');
          if(ftInit) {
            productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
          }
        }
        
        if(!productHandle && window.location.pathname.includes('/products/')) {
          productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
        }
        
        if(productHandle) {
          const fulfillmentType = await getFulfillmentFromPage(productHandle);
          
          if(fulfillmentType) {
            if(body instanceof FormData) {
              body.append('properties[Fulfillment]', fulfillmentType);
            } else if(typeof body === 'string') {
              const params = new URLSearchParams(body);
              params.append('properties[Fulfillment]', fulfillmentType);
              options.body = params.toString();
            }
          }
        }
        
      } catch(e) {}
    }
    
    return originalFetch.apply(this, args);
  };
  
  async function getFulfillmentFromPage(handle) {
    try {
      const pageResponse = await fetch(`/products/${handle}`);
      const pageHTML = await pageResponse.text();
      const ftInitMatch = pageHTML.match(/data-type=['"]?(ready|mto)['"]?/i);
      
      if(ftInitMatch) {
        return ftInitMatch[1] === 'ready' ? 'Ready to ship' : 'Made to order';
      }
    } catch(e) {}
    return 'Made to order';
  }
})();

// *************************
// Cart Drawer
// *************************

(function(){
  let updateThrottle;
  
  function hideRawProperties(){
    const drawer = document.querySelector('cart-drawer, .cart-drawer, [id^="CartDrawer"]');
    if(!drawer) return;
    
    drawer.querySelectorAll('.text-subdued li').forEach(li => {
      if(li.textContent.includes('Fulfillment')){
        li.remove();
      }
    });
  }
  
  function styleFulfillmentOnCartPage(){
    if(window.location.pathname !== '/cart') return;
    
    document.querySelectorAll('ul.text-subdued li').forEach(li => {
      if(li.textContent.includes('Fulfillment')) {
        li.style.listStyleType = 'none';
        li.style.marginLeft = '0';
        li.style.paddingLeft = '0';
      }
    });
  }
  
  async function updateCartDisplay(){
    if(updateThrottle) return;
    updateThrottle = setTimeout(() => updateThrottle = null, 2000);
    
    try{
      const res = await fetch('/cart.js', { cache: 'no-store' });
      if(!res.ok) return;
    
      const cart = await res.json();
      
      let hasReady = false, hasMTO = false, allReady = true, allMTO = true;
      
      for(const it of (cart.items || [])){
        const fulfillment = (it.properties && it.properties.Fulfillment || '').toLowerCase();
        if(fulfillment.includes('ready')) { hasReady = true; allMTO = false; }
        if(fulfillment.includes('order')) { hasMTO = true; allReady = false; }
      }
      
      const mixed = hasReady && hasMTO;
      const drawer = document.querySelector('cart-drawer, .cart-drawer, [id^="CartDrawer"]');
      if(!drawer) return;
      
      const inner = drawer.querySelector('[role="dialog"] .drawer__inner') || drawer;
      
      hideRawProperties();
      styleFulfillmentOnCartPage();
      
      let topBanner = drawer.querySelector('#hg-mixed-banner');
      if(!topBanner){
        topBanner = document.createElement('div');
        topBanner.id = 'hg-mixed-banner';
        topBanner.className = 'hg-mixed-banner hg-mixed-banner--cart';
        inner.prepend(topBanner);
      }
            
      if(cart.items.length === 0){
        topBanner.style.display = 'none';
      } else if(mixed){
        topBanner.innerHTML = '<strong>Order ships within 3 days</strong><br><br>This order contains both ready-to-ship and made-to-order items. The entire order will ship once all pieces are complete.';
        topBanner.style.display = 'block';
        addItemBadges(cart, drawer);
      } else if(allReady){
        topBanner.innerHTML = 'Order ships within <strong>2 days</strong>';
        topBanner.style.display = 'block';
      } else if(allMTO){
        topBanner.innerHTML = 'Order ships within <strong>3 days</strong>';
        topBanner.style.display = 'block';
      } else {
        topBanner.style.display = 'none';
      }

      let intlBanner = drawer.querySelector('#hg-intl-banner');
      if(!intlBanner){
        intlBanner = document.createElement('div');
        intlBanner.id = 'hg-intl-banner';
        intlBanner.className = 'hg-intl-banner hg-mixed-banner--cart';
        topBanner.insertAdjacentElement('afterend', intlBanner);
      }

      if(cart.items.length > 0 && window.HG?.countryCode !== 'US'){
          intlBanner.innerHTML = 'Shipping outside the U.S.? Import duties, VAT, and customs fees are the responsibility of the recipient upon delivery. <a href="/policies/shipping-policy" target="_blank" rel="noopener">Shipping Policy</a> · <a href="/policies/refund-policy" target="_blank" rel="noopener">Return Policy</a>';        intlBanner.style.display = 'block';
      } else {
          intlBanner.style.display = 'none';
      }
      
    }catch(e){}
  }
  
  function addItemBadges(cart, drawer){
    const items = drawer.querySelectorAll('line-item, .line-item');
    
    items.forEach((itemEl, idx) => {
      const cartItem = cart.items[idx];
      if(!cartItem) return;
      
      const fulfillment = (cartItem.properties && cartItem.properties.Fulfillment || '').toLowerCase();
      const isReady = fulfillment.includes('ready');
      
      const existing = itemEl.querySelector('.hg-badge');
      if(existing) existing.remove();
      
      if(fulfillment){
        const badge = document.createElement('div');
        badge.className = 'hg-badge hg-badge--' + (isReady ? 'ready' : 'mto');
        
        const icon = document.createElement('span');
        icon.className = 'hg-badge__icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = isReady ? '🚚' : '⏱️';
        
        const text = document.createElement('span');
        text.textContent = isReady ? 'Ready to ship' : 'Made to order';
        
        badge.appendChild(icon);
        badge.appendChild(text);
        
        const titleContainer = itemEl.querySelector('.v-stack');
        if(titleContainer) {
          titleContainer.appendChild(badge);
        }
      }
    });
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    updateCartDisplay();
    styleFulfillmentOnCartPage();
  });
  
  ['cart:updated','ajaxCart:afterAdd','shopify:section:load','shopify:section:select'].forEach(ev => {
    document.addEventListener(ev, () => {
      updateCartDisplay();
      styleFulfillmentOnCartPage();
    });
  });
  
  setTimeout(() => {
    const drawer = document.querySelector('cart-drawer, [id*="CartDrawer"]');
    if(drawer) {
      const obs = new MutationObserver(() => {
        hideRawProperties();
        updateCartDisplay();
      });
      obs.observe(drawer, { childList: true, subtree: true });
    }
  }, 1000);
})();